export const login = async () => {
    // for trainging -> home with login
    return {
        id: 4, 
        username: "bob",
        email: "bob@bob.com"
    };
};